$(document).ready(function () {
  $(window).on("scroll", function () {
    const $el = $("#element-template--25527388832126__rich_text_KEdyxV .rich-text__image");
    if ($el.length) {
      const deg = $(window).scrollTop() / 5;
      $el.css("--scroll-rotate", deg + "deg");
    }
  });
});

document.querySelectorAll('.appjetty-ddm-cart-box .dds-notes label').forEach(label => {
  label.innerHTML = label.innerHTML.replace(/(IMPORTANTE:)/g, '<span class="importante">$1</span>');
});

/*
$(document).ready(function() {
  function activarSubrayado() {
    const seccion = $('.rich-text__container');
    const palabra = $('.subrayable');

    const topSeccion = seccion.offset().top;
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();

    if (scrollTop + windowHeight > topSeccion + 100) { // Le da un pequeño margen
      palabra.addClass('subrayado-activo');
    }
  }

  $(window).on('scroll', activarSubrayado);
  activarSubrayado();
});
*/

$(document).ready(function () {
  function activarSubrayado() {
    const seccion = $('.rich-text__container');
    const palabra = $('.subrayable');

    if (seccion.length && palabra.length) {
      const topSeccion = seccion.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > topSeccion + 100) {
        palabra.addClass('subrayado-activo');
        // Quitamos el evento para que no siga comprobando una vez activado
        $(window).off('scroll', activarSubrayado);
      }
    }
  }

  // Detectar scroll
  $(window).on('scroll', activarSubrayado);

  // Por si ya está visible al cargar
  activarSubrayado();
});